var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 53.5,
    r: 41.7969,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 53.5,
    r: 50.9922,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 5.01562
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.7837 51.7858L48.6919 42.277C47.3661 41.4999 45.4004 42.277 45.4004 44.1514V63.1689C45.4004 64.9061 47.229 65.9576 48.6919 65.089L64.7837 55.5802C66.2009 54.7116 66.2009 52.6544 64.7837 51.7858Z",
    fill: "#FA0060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/video-play.fc33a2ad0ca63cf7d2bcd7ef07e5b558.svg";
export { ForwardRef as ReactComponent };